import React from 'react';
import styled from 'styled-components';
import ThinDivider from '../../../../../../components/ThinDivider';
import DashboardAddContentQueryTypes from '../DashboardAddContentQueryTypes';
import { floatingComponentStyles } from '../../../../../../styles/shareableStyles';
import SingleSelectOption from '../../../../../../components/Dropdown/SingleSelect/SingleSelectOption';
import KubitTooltip from '../../../../../../components/KubitTooltip';
import { INSERT_DISABLED_MESSAGE } from '../../../constants';

interface IProps {
  baseId: string;
  onAddImage: React.MouseEventHandler<HTMLButtonElement>;
  onAddMedia: React.MouseEventHandler<HTMLButtonElement>;
  onAddRichText: React.MouseEventHandler<HTMLButtonElement>;
  onAddReport: React.MouseEventHandler<HTMLButtonElement>;
  showCreateNewOption?: boolean;
  disableOptions?: boolean;
}

const Container = styled.div`
  min-width: 160px;
  ${floatingComponentStyles};
`;

const DashboardAddContentMenuItems = ({
  baseId,
  onAddImage,
  onAddMedia,
  onAddRichText,
  onAddReport,
  showCreateNewOption,
  disableOptions,
}: IProps) => {
  return (
    <Container>
      <KubitTooltip
        content={INSERT_DISABLED_MESSAGE}
        disabled={!disableOptions}
      >
        <SingleSelectOption
          iconName="magnifying-glass"
          label={'Existing Reports'}
          onClick={onAddReport}
          disabled={disableOptions}
        />
      </KubitTooltip>
      {showCreateNewOption && (
        <>
          <ThinDivider layout="horizontal" size="full" />
          <DashboardAddContentQueryTypes
            disabled={disableOptions}
            baseId={baseId}
          />
          <ThinDivider layout="horizontal" size="full" />
        </>
      )}
      <KubitTooltip
        content={INSERT_DISABLED_MESSAGE}
        disabled={!disableOptions}
      >
        <SingleSelectOption
          iconName="text"
          label={'Text'}
          onClick={onAddRichText}
          disabled={disableOptions}
        />
      </KubitTooltip>
      <KubitTooltip
        content={INSERT_DISABLED_MESSAGE}
        disabled={!disableOptions}
      >
        <SingleSelectOption
          iconName="image"
          label={'Image'}
          onClick={onAddImage}
          disabled={disableOptions}
        />
      </KubitTooltip>
      <KubitTooltip
        content={INSERT_DISABLED_MESSAGE}
        disabled={!disableOptions}
      >
        <SingleSelectOption
          iconName="monitor-play"
          label={'Media'}
          onClick={onAddMedia}
          disabled={disableOptions}
        />
      </KubitTooltip>
    </Container>
  );
};

export default DashboardAddContentMenuItems;
